import { baseUrl } from '@/config/env';
import request from '@/router/axios';
import { parseParam } from '@/util/util';

/* ============== 商家防水价格（面层防水/基坑防水阶段） ============== */
export const findWaterproofMerchantPrice = (params) => {
  params = parseParam(params);
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/merchantPrice/waterproof?` + params,
    method: 'GET',
  });
};
export const addWaterproofMerchantPrice = (data) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/merchantPrice/waterproof`,
    method: 'POST',
    data,
  });
};
export const updateWaterproofMerchantPrice = (data) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/merchantPrice/waterproof`,
    method: 'PUT',
    data,
  });
};
export const deleteWaterproofMerchantPrice = (ids) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/merchantPrice/waterproof/${ids}`,
    method: 'DELETE',
  });
};

/* ============== 商家回填价格（基坑回填阶段） ============== */
export const findBackfillMerchantPrice = (params) => {
  params = parseParam(params);
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/merchantPrice/backfill?` + params,
    method: 'GET',
  });
};
export const addBackfillMerchantPrice = (data) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/merchantPrice/backfill`,
    method: 'POST',
    data,
  });
};
export const updateBackfillMerchantPrice = (data) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/merchantPrice/backfill`,
    method: 'PUT',
    data,
  });
};
export const deleteBackfillMerchantPrice = (ids) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/merchantPrice/backfill/${ids}`,
    method: 'DELETE',
  });
};
